import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientSlide = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
`;

const StyledFooter = styled.footer`
  background: #1b5e20;
  color: white;
  text-align: center;
  padding: 3rem 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: linear-gradient(to right, #4CAF50, #ff9800, #4CAF50);
    animation: ${gradientSlide} 3s linear infinite;
  }

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

const FooterLink = styled.a`
  color: white;
  text-decoration: none;
  transition: transform 0.3s, color 0.3s;

  &:hover {
    transform: translateY(-3px);
    color: #4CAF50;
  }
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.8;
`;

const Footer: React.FC = () => {
  return (
    <StyledFooter id="contact">
      <FooterContent>
        <FooterLinks>
          <FooterLink href="#home">Home</FooterLink>
          <FooterLink href="#about">About</FooterLink>
          <FooterLink href="#pillars">Pillars</FooterLink>
          <FooterLink href="#impact">Impact</FooterLink>
          <FooterLink href="#research">Research</FooterLink>
        </FooterLinks>
        <FooterText>
          © 2023 Safe-Revive Africa. Transforming communities through integrated development.
        </FooterText>
      </FooterContent>
    </StyledFooter>
  );
};

export default Footer;